import axios from "@/lib/axios";
import { Resource } from "@/types/resources";

export type GetResourceByIdRequestParams = {
  companyId: string;
  resourceLibraryId: string;
  resourceId: string;
};

export type GetResourceByIdResponse = Resource;

export const getResourceById = (params: GetResourceByIdRequestParams) =>
  axios
    .get<GetResourceByIdResponse>(
      `/v1/companies/${params.companyId}/resource-libraries/${params.resourceLibraryId}/resources/${params.resourceId}`,
    )
    .then((res) => res.data);
